import { IService, logger } from "fly-boot";
import { GrpcService } from "./service.ts";
import { Server, ServerCredentials } from "@grpc/grpc-js";
import grpcConfig from "./config.ts";


class GrpcServerService implements IService {
    private readonly server: Server;
    constructor() {
        this.server = new Server();
    }

    addServices(services: Array<GrpcService>) {
        for (const { service, mapper } of services) {
            this.server.addService(service, mapper);
        }
    }

    async listen() {
        this.server.bindAsync(`${grpcConfig.host}:${grpcConfig.port}`, ServerCredentials.createInsecure(), (err, port) => {
            logger.success('grpc listening', `${grpcConfig.host}:${grpcConfig.port}`)
        });
    }
}

export default new GrpcServerService()